import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/small.png'
import _imports_1 from '@/assets/big.png'


const _withScopeId = n => (_pushScopeId("data-v-d7affe04"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "news" }
const _hoisted_2 = {
  key: 0,
  class: "news-top"
}
const _hoisted_3 = { class: "news-top-name" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "news-top-name-left-img",
  src: _imports_0
}, null, -1))
const _hoisted_5 = { class: "news-top-name-content" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "news-top-name-right-img",
  src: _imports_1
}, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "border" }, null, -1))
const _hoisted_8 = { class: "news-top-desc" }
const _hoisted_9 = { class: "news-bottom" }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { class: "news-bottom-news-box" }
const _hoisted_12 = ["src"]
const _hoisted_13 = { class: "news-bottom-news-box-content" }
const _hoisted_14 = { class: "news-bottom-news-name" }
const _hoisted_15 = ["innerHTML"]
const _hoisted_16 = { class: "news-bottom-news-detail" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "read-more" }, "阅读更多", -1))
const _hoisted_18 = {
  key: 1,
  class: "news-bottom-detail"
}
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", null, "更多资讯>>", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass({ newsMain: _ctx.titleFlag })
  }, [
    _createElementVNode("div", _hoisted_1, [
      (_ctx.titleFlag)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("span", _hoisted_3, [
              _hoisted_4,
              _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.newsModule.alias), 1),
              _hoisted_6
            ]),
            _hoisted_7,
            _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.newsModule.description), 1)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_9, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.newsList, (item, index) => {
          return (_openBlock(), _createElementBlock("a", {
            onClick: ($event: any) => (_ctx.newsDetail(item)),
            class: "news-bottom-news",
            key: index
          }, [
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", null, [
                _createElementVNode("img", {
                  src: item.img
                }, null, 8, _hoisted_12)
              ]),
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("span", null, _toDisplayString(item.name), 1)
                ]),
                _createElementVNode("div", {
                  class: "news-bottom-news-content",
                  innerHTML: item.content
                }, null, 8, _hoisted_15),
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("span", null, _toDisplayString(item.created_at.slice(0, 10)), 1),
                  _hoisted_17
                ])
              ])
            ])
          ], 8, _hoisted_10))
        }), 128))
      ]),
      (_ctx.titleFlag)
        ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
            _createVNode(_component_router_link, {
              to: { path: 'newsList', query: { id: _ctx.newsModule.id } }
            }, {
              default: _withCtx(() => [
                _hoisted_19
              ]),
              _: 1
            }, 8, ["to"])
          ]))
        : _createCommentVNode("", true)
    ])
  ], 2))
}